var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpNewWidthInside3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "346.5px",
    height: "412.5px",
    viewBox: "0 0 346.5 412.5",
    enableBackground: "new 0 0 346.5 412.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\t\t\t@font-face {\r\n\t\t\tfont-family: \"proximanova-nova\";\r\n\r\n\t\t\tsrc: url('https://doopsalta2.com/Fonts/proxima-nova-three.woff2') format('woff2'),\r\n\t\t\t\turl('https://doopsalta2.com/Fonts/proxima-nova-three.woff') format('woff'),\r\n\t\t\t\turl('https://doopsalta2.com/Fonts/proxima-nova-three.otf') format('opentype');\r\n\t\t\tfont-style: normal;\r\n\t\t\t}\r\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.3,
    y: 14.5,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 37.6,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 48.3,
    y1: 211,
    x2: 256.5,
    y2: 211
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "51,220 35.4,211 51,202  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "253.9,220 269.4,211 253.9,202  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M325,74.3l8.1-19.8h3.1l7.9,19.8h-2.9l-1.7-4.5h-9.9l-1.9,4.5H325z M330.3,67.7h8.4l-4.2-10.7L330.3,67.7z "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M327.4,220.5v-19.8h8.8c1.7,0,3.1,0.5,4.1,1.4c1,1,1.5,2.1,1.5,3.7c0,1.2-0.4,2.2-1,3 c-0.6,0.7-1.5,1.4-2.5,1.5c1,0.1,2,0.7,2.7,1.7c0.7,1,1.1,2,1.1,3.2c0,1.6-0.5,3-1.5,3.8c-1,1-2.5,1.5-4.2,1.5H327.4z  M329.9,209.2h6c1.1,0,2-0.2,2.5-0.9c0.5-0.6,0.9-1.4,0.9-2.2c0-0.9-0.2-1.7-0.9-2.4c-0.6-0.6-1.5-0.9-2.5-0.9h-6V209.2z  M329.9,218.3h6.1c1.1,0,2-0.2,2.7-0.9c0.7-0.6,1-1.5,1-2.5c0-1-0.4-1.7-1-2.5c-0.6-0.7-1.5-1-2.7-1h-6.1V218.3z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M326.9,355.5c-0.5-1.2-0.7-2.6-0.7-4.1s0.2-2.7,0.7-4.1s1.2-2.3,2-3.1c0.8-0.8,1.9-1.6,3.1-2 c1.2-0.5,2.5-0.7,3.8-0.7c3.1,0,5.5,1.3,7.3,3.8l-2,1.1c-0.6-0.8-1.3-1.6-2.3-2c-1-0.5-1.9-0.7-3-0.7c-2.2,0-3.8,0.7-5.3,2.2 c-1.4,1.4-2.2,3.3-2.2,5.6c0,1.4,0.4,2.9,1,4.1c0.6,1.2,1.6,2.2,2.6,2.7c1.1,0.6,2.4,1,3.7,1c1.1,0,2-0.2,3-0.7 c1-0.5,1.7-1.2,2.3-2l2,1.1c-1.9,2.5-4.3,3.8-7.3,3.8c-1.3,0-2.6-0.2-3.8-0.7c-1.2-0.5-2.3-1.2-3.1-2 C328,357.7,327.4,356.7,326.9,355.5z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 48.3,
    y1: 64.4,
    x2: 256.5,
    y2: 64.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "51,73.4 35.4,64.4 51,55.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "253.9,73.4 269.4,64.4 253.9,55.4  "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 48.3,
    y1: 351.4,
    x2: 256.5,
    y2: 351.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "51,360.4 35.4,351.4 51,342.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "253.9,360.4 269.4,351.4 253.9,342.4  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpNewWidthInside3);
export default __webpack_public_path__ + "static/media/help_new_width_inside_3.27b62cce84b114285c10942fef517f7c.svg";
export { ForwardRef as ReactComponent };